import * as React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


type Props = {
    buttonText:string,
    errorExplanationText:string,
    navRoot:string,
}
export const TimeoutMessage: React.FC<Props> = (props) => {
  const nav = useNavigate();
  const [t, i18n] = useTranslation();

  const closebuttonStyle: React.CSSProperties = {
    marginTop: '-70px',
    marginLeft: '280px',
    marginBottom: '30px'
  };
  const TimeoutMessageH1 = styled.p`
    font-weight: bold;
    font-size: 17px;
    line-height: 30px;
    color: #FFB16A;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    padding-top: 30px;
  `;
  const TimeoutMessageP = styled.p`
    font-weight: 400;
    font-size: 16px;
    line-height: 29px;
    color: #FFFBFB;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  `;
  const TimeoutMessageA = styled.button`
    padding: 8px 42px;
    gap: 10px;
    width: 300px;
    height: 37px;
    background: #FFB16A;
    border: 1px solid #FFB16A;
    border-radius: 40px;
    color: #FFFBFB;
    text-decoration: none;
    &:hover {
      opacity: 0.8;
      color: white;
    }
  `;
  // margin-top:50px;
  return (
    <div id="messege">
        <TimeoutMessageH1>{t(`ブロックチェーン上での処理を開始しました`)}<br/>{t(`完了までしばらくお待ちください`)}</TimeoutMessageH1>
        <TimeoutMessageA onClick={()=>nav(`/${props.navRoot}`)}>{t(props.buttonText)}</TimeoutMessageA>
    </div>
  );
};